export const FIELD_ARRAY_KEY_NAME = "fieldId";

export const ARRAY_FIELD_NAME = "data";
